'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import { ChevronRightIcon } from '@repo/ui/ChevronRightIcon'
import { useTheme } from '@mui/material/styles'

export const NavigationMenuItem = ({ label, icon, isSubMenu = false, sx }) => {
  const theme = useTheme()

  return (
    <MUIStack
      data-testid="NavigationMenuItem"
      sx={{ width: '100%', ...sx }}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <MUIStack direction="row" alignItems="center">
        {icon ? icon : null}
        {label}
      </MUIStack>
      {isSubMenu ? <ChevronRightIcon sx={{ color: theme.palette.text.secondary }} /> : null}
    </MUIStack>
  )
}

NavigationMenuItem.propTypes = {
  label: PropTypes.string,
  isSubMenu: PropTypes.bool,
  icon: PropTypes.any,
  sx: PropTypes.object
}
